import Vue from 'vue';

Vue.filter('capitalize', function(value) {
    if(!value) return '';
    value = value.toString();
    let arr = value.split(' ');
    let capitalizedArray = [];
    arr.forEach((word) => {
        let capitalized = word.charAt(0).toUpperCase() + word.slice(1);
        capitalizedArray.push(capitalized);
    });
    return capitalizedArray.join(' ');
});
